import React, { useEffect, useState } from "react";
import whatsapp from "../../Images/Group 534.png";
import arrow2 from "../../Images/Vector (11).png";
import heart from "../../Images/Vector (10).png";
import redHeart from "../../Images/red-heart.png";
import plus from "../../Images/Vector@2x.png";
import HomeService from "../../Services/HomeService";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import PropertyCard from "./PropertyCard";
import "./PropertyGrid.css"; // Import pagination CSS
import NewPropertyCard from "../WinnersHome/NewPropertList/NewPropertyCard"


const PropertyGrid = ({
  propertyData,
  loading,
  showFav,
  activeData,
  isClicked,
  favPropertyId,
  handleClick,
  currentPage,
  totalPages,
  onPageChange,
}) => {
  const [properties, setProperties] = useState([]);
  const [userId, setUserId] = useState("");
  const location = useLocation();
  const { filteredProperty } = location.state || [];
  const [remarks, setRemarks] = useState({});
  const [advertisementShowingOrder, setAdvertisementShowingOrder] =
    useState(null);

  useEffect(() => {
    if (propertyData && Array.isArray(propertyData)) {
      setProperties(propertyData);
    }
  }, [propertyData]);

  const fetchAdvertisementShowingOrder = async () => {
    try {
      const res = await HomeService?.getAdvertisementShowingOrder();
      if (res?.status) {
        setAdvertisementShowingOrder(res?.data[0]?.sequenceNumber);
      } else {
        setAdvertisementShowingOrder(null);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchAdvertisementShowingOrder();
  }, []);

  const fetchLoginProfile = async () => {
    try {
      const response = await HomeService.getProfile();
      setUserId(response.data?._id || "");
    } catch (error) {
      console.error("Error fetching login profile:", error);
    }
  };

  useEffect(() => {
    fetchLoginProfile();
  }, []);

  useEffect(() => {
    if (isClicked && favPropertyId && properties.length > 0) {
      setProperties((prevProperties) =>
        prevProperties.map((property) =>
          property._id === favPropertyId
            ? { ...property, isFavorite: !property.isFavorite }
            : property,
        ),
      );
    }
  }, [isClicked, favPropertyId]);

  const handleChangeRemarks = (id, value) => {
    setRemarks((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };

  // Generate page numbers for pagination
  const getPageNumbers = () => {
    const pageNumbers = [];
    const maxPagesToShow = 5; // Show max 5 page buttons

    if (totalPages <= maxPagesToShow) {
      // Show all pages if total pages are less than max to show
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      // Show first page, last page, and pages around current page
      const startPage = Math.max(1, currentPage - 2);
      const endPage = Math.min(totalPages, currentPage + 2);

      if (startPage > 1) {
        pageNumbers.push(1);
        if (startPage > 2) {
          pageNumbers.push("...");
        }
      }

      for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(i);
      }

      if (endPage < totalPages) {
        if (endPage < totalPages - 1) {
          pageNumbers.push("...");
        }
        pageNumbers.push(totalPages);
      }
    }

    return pageNumbers;
  };

  return (
    <>
      {loading && (
        <div className="property_grid_div text-center p-4">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-2">Loading properties...</p>
        </div>
      )}

      <div className="property_grid_div">
        {properties?.length === 0 && !loading ? (
          <div className="no_data_message text-center p-5">
            <h4>No Properties Found</h4>
            <p className="text-muted">Try adjusting your search criteria</p>
          </div>
        ) : (
          !loading && (
            <>
              {/* Properties Grid */}
              <div className="properties-grid-wrapper">
                {properties.map((property, index) => (
                  <PropertyCard
                    property={property}
                    index={index}
                    handleClick={handleClick}
                    showFav={showFav}
                    activeData={activeData}
                    advertisementShowingOrder={advertisementShowingOrder}
                    key={property._id || index}
                  />
                  // <NewPropertyCard
                  //   key={index}
                  //   property={property}
                  //   onViewDetails={(property) => {
                  //     localStorage.setItem("propertyId", property?._id);
                  //     window.open("/single-property", "_blank");
                  //   }}
                  // />
                ))}
              </div>

              {/* Pagination - Only show if totalPages > 1 */}
              {totalPages > 1 && (
                <div className="pagination-container">
                  <div className="pagination">
                    {/* Previous button */}
                    <button
                      className="pagination-button prev"
                      onClick={() => onPageChange(currentPage - 1)}
                      disabled={currentPage === 1}
                    >
                      <i className="fa-solid fa-chevron-left"></i> Previous
                    </button>

                    {/* Page numbers */}
                    <div className="page-numbers">
                      {getPageNumbers().map((page, index) =>
                        page === "..." ? (
                          <span key={`ellipsis-${index}`} className="ellipsis">
                            ...
                          </span>
                        ) : (
                          <button
                            key={page}
                            className={`page-number ${currentPage === page ? "active" : ""}`}
                            onClick={() => onPageChange(page)}
                          >
                            {page}
                          </button>
                        ),
                      )}
                    </div>

                    {/* Next button */}
                    <button
                      className="pagination-button next"
                      onClick={() => onPageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    >
                      Next <i className="fa-solid fa-chevron-right"></i>
                    </button>
                  </div>

                  {/* Showing info */}
                  <div style={{ display: "block" }} className="pagination-info">
                    Showing page {currentPage} of {totalPages}
                  </div>
                </div>
              )}
            </>
          )
        )}
      </div>
    </>
  );
};

export default PropertyGrid;
